import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { BaseService } from "../shared/services/base.service";

@Injectable({
  providedIn: 'root'
})
export class SanofiRulesService {

  public sanofiRuleDetails = new BehaviorSubject<any>(null);
  sanofiRuleDetails$ = this.sanofiRuleDetails.asObservable();

  constructor(public baseService: BaseService) { }

  public fetchSanofiRulesDetails(empId:string) {
    this.baseService.get(`sanofi-rules/getSanofiRules/${empId}`)
    .subscribe((res) => {
      this.sanofiRuleDetails.next(res);
    });
  }

  public downloadSanofiRuleExcel(sanofiRuleId:string): Observable<any> {
    return this.baseService.get(`sanofi-rules/excel-download/${sanofiRuleId}`)
  }

  public uploadSanofiRuleFileData(file, sanofiRuleId:string) {
    return this.baseService.postfile(`sanofi-rules/import-excel/${sanofiRuleId}`, file)
  }
}
